import { ProductListParams, useProductListParamsContext } from '@graphcommerce/magento-product'
import { useProductListLink } from '@graphcommerce/magento-product/hooks/useProductListLink'
import { Link, LinkProps } from '@mui/material'
import PageLink, { LinkProps as PageLinkProps } from 'next/link'
import React from 'react'


export type ProductListLinkProps = LinkProps &
  ProductListParams & {
    noLink?: boolean
    link?: Omit<PageLinkProps, 'href' | 'passHref'>
    children?: React.ReactNode
    selected?: boolean
  }

export const ProductListLink = React.forwardRef<HTMLAnchorElement, ProductListLinkProps>(
  (props, ref) => {
    const { setParams } = useProductListParamsContext();
    const {
      children,
      url,
      sort,
      currentPage,
      pageSize,
      filters,
      paddingLeft,
      search,
      noLink,
      link,
      selected,
      ...linkProps
    } = props
    const newParams = { filters, sort, url, currentPage, pageSize, search }

    const productListLink = useProductListLink(newParams)
    const updateParams = () => setParams(newParams)

    // We're setting nofollow if a custom sort, pageSize, filters or search is set.
    let rel: string | undefined
    if (Object.keys(sort).length || pageSize || Object.keys(filters).length || search)
      rel = 'nofollow'

    return noLink ? (
      <PageLink href={productListLink} passHref {...link} legacyBehavior>
        {children}
      </PageLink>
    ) : (
      <Link
        href={productListLink}
        rel={rel}
        underline='hover'
        {...linkProps}
        ref={ref}
        onClick={updateParams}
        className={`hover:bg-primary-500 hover:text-white transition-colors w-7 h-7 text-sm rounded-sm flex items-center justify-center ${selected && 'bg-primary-500 text-white'}`}
      >
        {children}
      </Link>
    )
  },
)